// TanStack Query hooky pro meteogramy ALADIN (/api/meteogram_points, /api/meteogram_runs)
import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { useDebounce } from './useDebounce'

// Fulltext vyhledávání bodů (obce, letiště, stanice ČHMÚ, lyžařská střediska, vodní plochy).
// query se debouncuje (300 ms), dotaz jde na server až od 2 znaků.
export function useMeteogramSearch(query, category) {
  const debouncedQuery = useDebounce(query, 300)
  const q = debouncedQuery.trim()
  const enabled = q.length >= 2

  const { data = [], isFetching } = useQuery({
    queryKey: ['meteogram-points', q, category ?? null],
    queryFn: () => {
      const params = new URLSearchParams({ q, limit: '30' })
      if (category) params.set('category', category)
      return api.get(`/meteogram_points?${params}`)
    },
    enabled,
    staleTime: 60_000,
  })

  return { results: enabled ? data : [], isLoading: enabled && isFetching }
}

// Poslední N dostupných běhů modelu ALADIN (00/06/12/18 UTC), nejnovější první.
export function useMeteogramRuns(limit = 4) {
  const { data = [], isLoading } = useQuery({
    queryKey: ['meteogram-runs', limit],
    queryFn: () => api.get(`/meteogram_runs?limit=${limit}`),
    staleTime: 5 * 60_000,
  })
  return { runs: data, isLoading }
}
